import {Button} from "antd";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import React, {useRef} from "react";
import ContentExam from "./ContentExam";

const Modal = () => {
  const modalRef = useRef<any>();
  return (
    <div className="container">
      <Button
        onClick={() => {
          modalRef.current?.openModal();
        }}
        type="primary"
      >
        Mở modal
      </Button>
      <ModalCustom ref={modalRef} title="Example Modal">
        <ContentExam data="Content of Modal"></ContentExam>
      </ModalCustom>
    </div>
  );
};
export default Modal;
